import angular from 'angular';
import '../../shared.module';
import template from './select.component.html';
import './select.component.scss';
import { nextFieldId } from '../../helpers/field-id.helper';

class SelectController {
  $onInit() {
    this.fieldId = nextFieldId();
    this.ngModelCtrl.$render = () => {
      const value = this.ngModelCtrl.$viewValue;
      const blank = value === '' && Boolean(this.placeholder) && !this.hasEmptyOption();
      if (blank) this.emptyAsString = true;
      this.value = blank ? null : value;
    };
  }

  hasEmptyOption() {
    return (this.options || []).some((option) => option.value === '');
  }

  handleChange() {
    const placeholderPicked = this.value === null || this.value === undefined;
    this.ngModelCtrl.$setViewValue(placeholderPicked && this.emptyAsString ? '' : this.value);
  }
}

angular.module('app.shared').component('cpSelect', {
  bindings: {
    label: '@',
    options: '<',
    placeholder: '@',
    hint: '@',
    error: '@',
    disabled: '<'
  },
  require: { ngModelCtrl: 'ngModel' },
  controller: SelectController,
  controllerAs: 'vm',
  template
});
